export enum eSteps {
  StepAddress = 3,
  StepCongratz = 5,
  StepCredential = 4,
  StepPersonalInformation = 2,
  StepType = 1,
}

export enum eCompanySteps {
  StepAddress = 2,
  StepCongratz = 5,
  StepCredential = 4,
  StepPersonalInformation = 3,
  StepType = 1,
}

export enum eUserOnlySteps {
  StepPersonalInformation = 1,
  StepCongratz = 3,
  StepCredential = 2,
}

export enum eCompanyOnlySteps {
  StepType = 1,
  StepAddress = 2,
  StepCongratz = 3,
}

export enum eWorkSpaceSteps {
  StepAddress = 1,
}

export enum eMyKsuiteUpgradeAccountSteps {
  StepType = 1,
  StepAddress = 2,
}

export enum EMyKsuiteSteps {
  StepSelectUser = 1,
  StepPersonalInformation = 2,
  StepCredential = 3,
  StepPhone = 4,
}

export enum EMyKsuiteConnectedSteps {
  StepSelectUser = 1,
  StepCredential = 2,
  StepPhone = 3,
}

export type eStepsTypes =
  | eSteps
  | eCompanySteps
  | eUserOnlySteps
  | eWorkSpaceSteps
  | EMyKsuiteSteps
  | EMyKsuiteConnectedSteps;

export enum eContext {
  SignupStandalone,
  Order,
  Invitation,
}

export enum eType {
  Individual = 'individual',
  Company = 'company',
  PublicBody = 'public_body',
  Association = 'association',
}

export enum eInvitation {
  Account = 'invitation_account',
  Drive = 'invitation_drive',
  Webmail = 'invitation_webmail',
  Webmail1 = 'invitation_webmail1',
  Transfer = 'invitation_transfer',
  Agenda = 'invitation_calendar',
  Contact = 'invitation_contact',
  Password = 'invitation_password_reset',
  Partner = 'invitation_b2b_partner',
  PartnerCustomer = 'invitation_b2b_customer',
  Ksuite = 'invitation_ksuite',
  KsuiteMailbox = 'invitation_webmail_ksuite',
  KChat = 'invitation_kchat',
}

export type tStatus =
  | 'accepted'
  | 'cancelled'
  | 'expired'
  | 'rejected'
  | 'user_not_matching'
  | 'user_matching_invited_by'
  | 'too_many_request'
  | 'mail_not_hosted'
  | 'current_user_link'
  | 'error'
  | 'pending'
  | 'pending_auth'
  | 'pending_create'
  | 'pending_password'
  | 'deleted'
  | 'user_already_in_ksuite';

export type tState =
  | 'signup'
  | 'signup_affiliation'
  | 'signup_promotional_1500'
  | 'signup_tickets'
  | 'invitations'
  | 'order'
  | any;

export enum sessionKeys {
  skipFirstStep = 'skipfirststep',
}

export interface IUser {
  id: number;
  login: string;
  email: string;
  first_name: string;
  last_name: string;
  avatar_url: string;
}
